export type VariantTypes = 'white' | 'primary' | 'secondary' | 'tertiary' | 'success' | 'danger' | 'warning';
export type TextVariantTypes = keyof typeof textVariants;
export const variants: VariantTypes[] = ['white', 'primary', 'secondary', 'tertiary', 'success', 'danger', 'warning'];

export const bgVariants = {
	white: ['text-white'],
	primary: ['bg-primary-500'],
	secondary: ['bg-secondary-500'],
	tertiary: ['bg-dark-800'],
	success: ['bg-success-500'],
	danger: ['bg-danger-500'],
	warning: ['bg-warning-500'],
};

export const textVariants = {
	primary: ['text-primary-500'],
	secondary: ['text-secondary-500'],
	tertiary: ['text-dark-800'],
	success: ['text-success-500'],
	danger: ['text-danger-500'],
	warning: ['text-warning-500'],
	white: ['text-white'],
	gold: ['text-gold-500'],
	silver: ['text-silver-500'],
	bronze: ['text-bronze-500'],
	dark950: ['text-dark-950'],
	warning700: ['text-warning-800'],
};

export const borderVariants = {
	primary: ['border-primary-500'],
	secondary: ['border-secondary-500'],
	tertiary: ['border-dark-800'],
	success: ['border-success-500'],
	danger: ['border-danger-500'],
	warning: ['border-warning-500'],
	white: ['text-white'],
};
